module.exports = __webpack_public_path__ + "img/badge_refazi_scadenzario_az.58ef342a.jpg";